module.exports = __webpack_public_path__ + "static/img/role.865d955.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/jw/role.png
// module id = yvVP
// module chunks = 7